import { generatePath, useOutletContext } from 'react-router-dom';

import { PayoutType } from 'types';
import { mapQuery } from 'utils/query';
import { Messages, AppRoutes } from 'config';
import { TransactionsList } from 'components';
import { Payout, useListQuery, useDeleteMutation } from 'store/api/payout';
import {
  isMobile,
  useFilter,
  useShowMore,
  useNavigate,
  handleMutation,
  useSearchQuery,
} from 'hooks';

import { OutletContext } from '../../types';
import { usePaymentMonth } from '../month-scope';
import {
  getCommonListProps,
  advanceBonusCellsMobile,
  getAdvanceBonusExtendRender,
} from '../config';

const { New, Details } = AppRoutes.Profile.Bonuses;

export const Bonuses = () => {
  const mobile = isMobile();
  const navigate = useNavigate();
  const month = usePaymentMonth();
  const { userData, isCompanyOwner } = useOutletContext<OutletContext>();
  const { debounceQuery, ...search } = useSearchQuery();

  const { currentData: payouts, ...payoutsProps } = useListQuery(
    {
      month,
      id: String(userData?.id),
      types: JSON.stringify([PayoutType.Bonus, PayoutType.PrepaidBonus]),
    },
    { skip: !userData?.id }
  );

  const filteredData = useFilter<Payout>({
    data: payouts || [],
    query: debounceQuery,
    paths: ['event.name', 'amount', 'notes'],
  });

  const [remove, mutation] = useDeleteMutation();
  handleMutation({
    ...mutation,
    successMessage: `Bonus ${Messages.DELETED_SUCCESSFULLY}`,
  });

  const { visibleData, ...showMoreProps } = useShowMore(filteredData);

  return (
    <TransactionsList
      {...getCommonListProps(filteredData)}
      title="Bonuses"
      createPath={New}
      data={visibleData}
      isFooterCreateButton
      cellsMobile={advanceBonusCellsMobile}
      createTitle={isCompanyOwner ? 'New bonus' : undefined}
      template={isCompanyOwner ? '1fr 3fr 1fr 1fr 1fr 184px' : undefined}
      listProps={{ ...mapQuery(payoutsProps), ...search, ...showMoreProps }}
      onClick={(e, value) =>
        navigate(generatePath(Details, { bonusId: value.id?.toString() }))
      }
      extendRender={getAdvanceBonusExtendRender({
        mobile,
        remove,
        isCompanyOwner,
        type: PayoutType.Bonus,
      })}
    />
  );
};
